import React, { useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import HelpIcon from "@material-ui/icons/Help";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Popper from "@material-ui/core/Popper";
import { withRouter } from "react-router-dom";
import theme from "../../layout/theme";

const tema = theme();

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    backgroundColor: "#fbfbfb",
    marginLeft: "5%",
    marginRight: "5%",
    width: "90%",
    borderRadius: 4,
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  },
  campoTexto: {
    marginBottom: 8,
  },
  poperIndex: {
    zIndex: "2000",
  },
  obrigatorio: {
    color: "red",
    fontSize: "1em",
  },
  tituloAjuda: {
    color: tema.theme.primary,
    paddingTop: 0,
    marginTop: 0,
    textAlign: "center",
  },
  textoAjuda: {
    color: "#002d4e",
  },
}));

function CampoTextoAjuda(props) {
  const classes = useStyles();
  const {
    disabled = false,
    label,
    error,
    helperText,
    onChange,
    value,
    className,
    tituloAjuda,
    textoAjuda,
    saibaMais,
    obrigatorio = true,
    buscaForm = false,
    history,
    InputProps = {},
    onBlur,
    type = "text",
    required = false,
    multiline = false,
    rows = 1,
  } = props;

  const [open, setOpen] = React.useState(false);

  const inputRef = useRef(null);

  const handleClickAway = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(!open);
  };

  //Motivo: Será utilizado ao implementar a aba de ajudas
  // eslint-disable-next-line no-unused-vars
  function vaiSaibaMais() {
    history.push(`/ajuda/${saibaMais.categoria}/${saibaMais.campo}`);
  }

  return (
    <>
      <TextField
        disabled={disabled}
        aria-describedby="campo-ajuda"
        ref={inputRef}
        className={className ? className : classes.campoTexto}
        label={label}
        type={type}
        variant="outlined"
        required={required}
        multiline={multiline}
        fullWidth
        rows={rows}
        error={error}
        helperText={error ? helperText : ''}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        PopperComponent={{}}
        InputProps={Object.assign(
          {},
          {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleTooltipOpen}
                  edge="end"
                >
                  <HelpIcon />
                </IconButton>
              </InputAdornment>
            ),
          },
          InputProps,
          { className: buscaForm ? className : "" }
        )}
      />
      <Popper
        open={open}
        anchorEl={inputRef && inputRef.current}
        className={classes.poperIndex}
        placement="top-start"
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className={classes.paper}>
            <h3 className={classes.tituloAjuda}>{tituloAjuda}</h3>
            <p className={classes.textoAjuda}>
              {obrigatorio && (
                <span className={classes.obrigatorio}>Campo Obrigatorio. </span>
              )}
              {textoAjuda}
            </p>
            {/* <Button onClick={vaiSaibaMais}>Saiba Mais</Button> */}
          </div>
        </ClickAwayListener>
      </Popper>
    </>
  );
}

export default withRouter(CampoTextoAjuda);
